<template>
  <div id="printBagNumber" ref="printBagNumber" class="fontSizeStyle">
    <!-- 隐藏标记，用于 JS 检测当前打印尺寸 -->
    <div id="paperSizeDetector" :style="{ display: 'none' }" class="paper-size-detector" />
    <div ref="printBagNumberContent" class="printBagNumberContent">
      <div style="display: flex; align-items: center">
        <img :src="require('@/assets/ajlogo1.svg')" alt="tu" style="width: 100px">
        <div
          style="
            font-size: 20px;
            text-align: center;
            flex: 1;
            font-weight: bold;
            margin-left: -100px;
          "
        >
          {{ $t('scripting.returnCodeList') }}
        </div>
      </div>
      <div style="margin: 10px 0">
        {{ $t('seller.licensePlateNumber') }}: {{ paramData[0].vehicleNumber }}
      </div>
      <table class="print-table" style="width: 100%; text-align: center">
        <thead>
          <tr class="print-table-header" style="background-color: #add88d">
            <th>{{ $t('GlobalSetObj.serial') }}</th>
            <th>{{ $t('navbar.siteName') }}</th>
            <th>{{ $t('scripting.returnCode') }}</th>
            <th>{{ $t('scripting.expiryTime') }}</th>
            <th>{{ $t('collectionCenter.Barcode') }}</th>
          </tr>
        </thead>
        <tbody style="text-align: center">
          <tr v-for="(item, index) in paramData">
            <td>{{ index + 1 || '--' }}</td>
            <td>{{ item.nextSiteIdName || '--' }}</td>
            <td>{{ item.returnCode || '--' }}</td>
            <td>{{ item.abortTime || '--' }}</td>
            <td style="text-align: center; vertical-align: middle">
              <div style="display: flex; justify-content: center; align-items: center; width: 100%">
                <svg :id="item.returnCode" style="display: block; margin: 0 auto" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import printXq from 'print-js';
import JsBarcode from 'jsbarcode';

export default {
  props: {
    paramData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      qrData: ''
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.print01();
    },
    print01() {
      const _this = this;
      console.log(this.paramData, 'this.paramData');
      _this.$nextTick(() => {
        const generateBarcodeAll = [];
        this.paramData.forEach((item) => {
          generateBarcodeAll.push(this.generateBarcode(item.returnCode, item.returnCode));
        });
        console.log(generateBarcodeAll, 'generateBarcodeAll');
        Promise.all(generateBarcodeAll).then(() => {
          printXq({
            showModal: true,
            modalMessage: 'loading...',
            printable: 'printBagNumber', // // 文档来源：pdf或图像的url，html元素的id或json数据的对象
            type: 'html', // 可打印的类型。可用的打印选项包括：pdf，html，图像，json和raw-html。
            targetStyles: ['*'], // 库在打印HTML元素时处理任何样式
            font_size: ''
          });
          _this.$emit('hiddenBagNumberHtml');
        });
      });
    },
    isA6Paper() {
      const detector = document.querySelector('.paper-size-detector');
      if (!detector) return false;
      const content = window.getComputedStyle(detector, '::after').content;
      return content.includes('A6');
    },
    generateBarcode(code) {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          // 检测纸张大小，动态调整条形码尺寸
          const isA6 = this.isA6Paper();
          JsBarcode('#' + code, code, {
            height: isA6 ? 35 : 60,
            width: 1,
            displayValue: false,
            valid: () => resolve(null)
          });
        });
      });
    }
  }
};
</script>
<style scoped>
.fontSizeStyle * {
  font-size: 16px;
  box-sizing: border-box;
}

.printBagNumberContent {
  break-inside: avoid;
}

/* 不同纸张尺寸下显示不同内容 */
@media print and (max-width: 110mm) {
  .paper-size-detector::after {
    content: 'A6';
  }
}

@media print and (min-width: 111mm) and (max-width: 160mm) {
  .paper-size-detector::after {
    content: 'A5';
  }
}

@media print and (min-width: 161mm) {
  .paper-size-detector::after {
    content: 'A4';
  }
}
</style>
<style>
/*
 * 边框样式必须写在非 scoped 的 <style> 中，原因：
 * 1. print-js 复制 HTML 到打印 iframe 时，不会携带 Vue scoped 的 [data-v-xxx] 属性，
 *    scoped 选择器在 iframe 中无法匹配，边框样式全部失效；
 * 2. print-js 的 targetStyles:['*'] 只复制屏幕渲染的 computedStyle，
 *    @media print 规则不会出现在 computedStyle 中，对 print-js 也无效；
 * 3. Firefox 打印不渲染 border-collapse:collapse 的内边框，
 *    必须使用 separate + border-spacing:0 + 显式单元格边框方案。
 */
.print-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #000;
}

.print-table th,
.print-table td {
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  padding: 5px;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
  text-align: center;
  vertical-align: middle;
}

/* 强制条形码居中 */
.print-table td:last-child {
  text-align: center !important;
  vertical-align: middle !important;
}

@media print {
  @page {
    size: 10cm 15cm;
    margin: 0;
  }

  #printBagNumber {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    page-break-before: auto;
    page-break-after: auto;
    overflow: hidden;
  }

  /* 打印时强制居中 */
  .print-table td:last-child {
    text-align: center !important;
    vertical-align: middle !important;
  }
}
</style>
